import { Component, OnInit, forwardRef, Input, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
declare var jQuery: any;

@Component({
  selector: 'quantity-filter',
  templateUrl: './quantity-filter.component.html',
  styleUrls: ['./quantity-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuantityFilterComponent),
      multi: true
    }
  ]
})
export class QuantityFilterComponent implements ControlValueAccessor {
  @Input() value: string;
  propagateChange = (_: any) => { };

  writeValue(value: any): void {
    if (value !== undefined) {
      // If a value is provided to the Component
      if (this.value && String(this.value).length) { // Is Not an Empty String
        this.value = value;
      }
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }



  constructor(private elRef: ElementRef) { }

  ngOnInit() {
    jQuery(this.elRef.nativeElement).find('#quantity-filter').slider({
      range: true,
      min: 1,
      max: 33,
      values: [1, 33],
      slide: function (event, ui) {
        this.propagateChange(ui.values[0] + "-" + ui.values[1]);
        jQuery('#slider-indicator').html(ui.values[0] + " - " + ui.values[1]);
      }.bind(this)
    });

    jQuery(this.elRef.nativeElement).find('.ui-slider-range').css('background', '#3286CC'); // Can't change color in CSS, so we manually set it here.
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/quantity-filter/quantity-filter.component.ts